export default function typeAssert(data, typeObject, noDefined) {
    const keys = Object.keys(typeObject);
    if (data.type) {
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (data.type === key) {
                return typeObject[key](data);
            }
        }
        return noDefined(data);
    }
    return noDefined(data);
}
//# sourceMappingURL=typeAssert.util.js.map